module.exports = __webpack_public_path__ + "static/images/tutorial-2-ical.5198e37c6b5ffc53d4a37df3664ad39a.svg";